module.exports = __webpack_public_path__ + "img/hero-about.2a15a066.png";